module.exports = __webpack_public_path__ + "img/section_cash.daf4f7f9.png";